import '../../vendor/slick.min'

export default {

    init() {
        /* Script pour le module vidéo avec curseur, preview et ligne élastique */
        if ($(".module-apropos-employes")[0]) {
            $('.module-apropos-employes .container_profiles .profiles').slick({
                dots: false,
                infinite: false,
                speed: 300,
                slidesToShow: 3,
                slidesToScroll: 1,
                responsive: [
                  {
                    breakpoint: 1024,
                    settings: {
                      slidesToShow: 3,
                      slidesToScroll: 3,
                      infinite: true,
                      dots: true
                    }
                  },
                  {
                    breakpoint: 600,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2
                    }
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      slidesToShow: 1.2,
                      slidesToScroll: 1
                    }
                  }
                ]
              });
        }
    },
};